import styled from "styled-components";
import { BodyText, SubheaderText, TitleText } from "../components/Text";
import { uid } from "../utils";
import { mediaQueries } from "../common/constants";
import Footer from "../components/Footer";

const MeetTheTeam = () => {
	const data = [
		{
			title: "Directors",
			portraits: [
				{
					text: "Anat Ben Israel\nExecutive Director",
					img: "/img/Screen Shot 2022-08-31 at 23.55.20 2.jpeg"
				},
				{
					text: "Carlien van Heel\nExecutive Director",
					img: "/img/carlien.png"
				},
				{
					text: "Claudia de Campos\nExecutive Director",
					img: "/img/claudia.jpg"
				},
				{
					text: `Hilary Price\nExecutive Director`,
					img: "/img/20230621_063246.jpg"
				},
				{
					text: "Lauren Liebling Davis\nnon-Executive Director",
					img: "/img/Lauren.png"
				}
			]
		},
		{
			title: "Training Board",
			text: `The Training Board is a group of senior trainers who meet regularly to plan, discuss and decide on the delivery of the Diploma Course and the Continuing Professional Development of Trainee Biodynamic Psychotherapists`,
			portraits: [
				{
					text: "Anat Ben Israel",
					img: "/img/Screen Shot 2022-08-31 at 23.55.20 2.jpeg"
				},
				{
					text: "Carlien van Heel",
					img: "/img/carlien.png"
				},
				{
					text: "Claudia de Campos",
					img: "/img/claudia.jpg"
				},
				{
					text: "Hilary Price",
					img: "/img/20230621_063246.jpg"
				},
				{
					text: "Michelle Quoilin",
					img: "/img/45224ae9-48a6-43cf-b6ef-106de3e77cee.jpg"
				}
			]
		},
		{
			title: "Support Staff",
			portraits: [
				{
					text: "Anwen O’Dell\nFinance Administrator",
					img: "/img/Anwen.jpg"
				},
				{
					text: "Helen England\nTraining Administrator",
					img: "/img/Helen.jpeg"
				},
				{
					text: "Toby Harrison\nPremises Manager",
					img: "/img/Toby Harrison.jpg"
				}
			]
		}
	];

	return (
		<>
			<TitleText>Meet The Team</TitleText>
			{data.map(({ title, text, portraits }) => {
				return (
					<div key={uid()}>
						<StyledSubheader>{title}</StyledSubheader>
						{text ? (
							<CenteredBodyText>{text}</CenteredBodyText>
						) : null}
						<FlexContainer>
							{portraits.map(({ img, text }) => {
								return (
									<div key={uid()}>
										<Portrait key={uid()} src={img} />
										{text ? (
											<CenteredBodyText>
												{text}
											</CenteredBodyText>
										) : null}
									</div>
								);
							})}
						</FlexContainer>
					</div>
				);
			})}
			<Footer />
		</>
	);
};

export default MeetTheTeam;

/** Other Components */

/** Styled Components */

const Portrait = styled.img`
	display: block;
	object-fit: cover;
	object-position: top;
	width: 180px;
	height: 300px;
	margin: 30px 60px 0;

	${mediaQueries.extraSmallScreens} {
		width: 200px;
		height: 250px;
		margin: 0 auto;
	}
`;

const FlexContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
`;

const StyledSubheader = styled(SubheaderText)`
	margin: 30px 0;
`;

const CenteredBodyText = styled(BodyText)`
	text-align: center;
	white-space: break-spaces;
`;
